import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////////// articles ////////////////////
const articlesUrl = "articles";
// get all articles data
export const getArticlesDataRequest = (values) =>
  client.get(articlesUrl, values);

// add article
export const addArticleRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  formData.append("show_in_home_page", values.show_in_home_page);
  values.category_id && formData.append("category_id", values.category_id);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  values.video.isChanged && formData.append("video", values.video.url);

  return client.post(`admin/${articlesUrl}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

// update article
export const updateArticleRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  values.title && formData.append("title", values.title);
  values.text && formData.append("text", values.text);
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  formData.append("show_in_home_page", values.show_in_home_page);
  values.category_id && formData.append("category_id", values.category_id);
  !values.main_image.isWeb &&
    formData.append("main_image", values.main_image.url);
  values.video.isChanged && formData.append("video", values.video.url);

  return client.post(
    `admin/${articlesUrl}/${values.id}?_method=put`,
    formData,
    {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    }
  );
};

// get article by id
export const getArticleByIdRequest = (values) => {
  return client.get(`${articlesUrl}/${values.id}`);
};
// delete articles by id
export const deleteArticleByIdRequest = (id) =>
  client.delete(`admin/${articlesUrl}/${id}`);

/////// articles category ///////
const articleCategoryUrl = "/article_categories";
// get all articles category
export const getArticleCategoryRequest = (values) =>
  client.get(`${articleCategoryUrl}?
  skip=${values.skip ?? 0}&limit=${values.limit ?? 10}
    ${values.search ? "&search=" + convertNum(values.search) : ""}`);

// get articles category by id
export const getArticleCategoryByIdRequest = (values) =>
  client.get(`${articleCategoryUrl}/${values.id}`);

// add articles category
export const addArticleCategoryRequest = (values) =>
  client.post(`/admin${articleCategoryUrl}`, values);

// edit articles subcategory
export const editArticleCategoryRequest = (values) =>
  client.put(`/admin${articleCategoryUrl}/${values.id}`, values);
// delete articles subcategory
export const deleteArticleCategoryByIdRequest = (id) =>
  client.delete(`/admin${articleCategoryUrl}/${id}`);
